import { Badge } from '@mantine/core';
import type { EntityRegistryEntry, ColumnOptions } from '../types';
import type { TableColumn } from '../../components/common/GenericTable';

export const modificationErrorConfig: EntityRegistryEntry = {
    hideIdInStandard: true,
    tableFlags: {
        createDisabled: true,
        sortingDisabled: true,
    },
    detailTabs: { hideJournalTab: true },
    listColumns: (options: ColumnOptions): TableColumn<any>[] => {
        const cols: TableColumn<any>[] = [
            {
                key: 'displayName',
                label: 'Error',
                title: 'DisplayName',
                render: (entity: any) => {
                    const name = entity?.DisplayName || entity?.rawData?.DisplayName || '';
                    return name.length > 60 ? `${name.substring(0, 57)}…` : name;
                },
            },
            {
                key: 'modificationType',
                label: 'Action',
                title: 'ModificationType',
                render: (entity: any) => {
                    const val = entity?.ModificationType || entity?.rawData?.ModificationType;
                    if (!val) return null;
                    const color = val.toLowerCase() === 'delete' ? 'red' : val.toLowerCase() === 'create' ? 'green' : 'blue';
                    return Badge({ variant: 'light', color, size: 'xs', children: val });
                },
            },
            {
                key: 'source',
                label: 'Source',
                title: 'Source',
                render: (entity: any) => {
                    const val = entity?.Source || entity?.rawData?.Source;
                    if (!val) return null;
                    return Badge({ variant: 'outline', color: 'cyan', size: 'xs', children: val });
                },
            },
            {
                key: 'actorDisplayName',
                label: 'Actor',
                title: 'ActorDisplayName',
            },
            {
                key: 'targetDisplayName',
                label: 'Target',
                title: 'TargetDisplayName',
            },
            {
                key: 'acknowledged',
                label: 'Ack',
                title: 'Acknowledged',
                render: (entity: any) => {
                    const val = entity?.Acknowledged ?? entity?.rawData?.Acknowledged;
                    if (val === true) return Badge({ variant: 'filled', color: 'green', size: 'xs', children: 'Yes' });
                    return Badge({ variant: 'outline', color: 'gray', size: 'xs', children: 'No' });
                },
            },
        ];

        if (!options.isStandard) {
            cols.push({
                key: 'recorded',
                label: 'Recorded',
                title: 'Recorded',
                render: (entity: any) => {
                    const val = entity?.Recorded || entity?.rawData?.Recorded;
                    if (!val) return null;
                    try { return new Date(val).toLocaleString(); } catch { return val; }
                },
            });
        }

        return cols;
    },
};
